// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
import './assets/css/mycalendar.less'
import 'swiper/swiper-bundle.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.config.productionTip = false
Vue.prototype.serverUrl = '/';
if (process.env.NODE_ENV==='development'){
  Vue.prototype.serverUrl = 'http://api.o.com.cn/';
}
Vue.prototype.axios = axios;

var share2wx = {
  'title':'健康日历',
  'desc':'骨科大夫，传播靠谱的骨科科普。',
  'imgUrl':'http://www.gukedf.com.cn/assets/web/images/logo-wx.png',
  'link':window.location.href.split('#')[0]
};
Vue.prototype.share2wx = share2wx;
Vue.use(AlloyFingerPlugin, {
  AlloyFinger
})
Vue.use(VueAwesomeSwiper)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js